<ion-header class="ion-no-border">
    
	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-button (click)="close()">
				<fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
		<ion-title>Pickup</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="update()">
				<fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>

</ion-header>

<ion-content>

    <ion-grid class="form">
        <ion-row>
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <ion-input *ngIf="params['pickup_date']" class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" value={{formatted_pickup_date}} (click)="presentDateTimePickerModal()">
                                <div slot="label">Pickup date<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                            <ion-input *ngIf="!params['pickup_date']" class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentDateTimePickerModal()">
                                <div slot="label">Pickup date<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>
